import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_LINK_PAYMENT_STATUS_DEF,
} from "./actionTypes"

import {
  getLinkPaymentStatusDefListSuccess,
  linkPaymentStatusDefApiError
} from "./actions"

import {
  getAllLinkPaymentStatus,
} from "../../helpers/backend_helper/backend_helper"

function* onGetLinkPaymentStatusDefList() {
  try {
    const response = yield call(getAllLinkPaymentStatus)
    yield put(getLinkPaymentStatusDefListSuccess(response))
  } catch (error) {
    yield put(linkPaymentStatusDefApiError(error))
  }
}

function* linkPaymentStatusDefSaga() {
    yield takeEvery(GET_LINK_PAYMENT_STATUS_DEF,onGetLinkPaymentStatusDefList)
}

export default linkPaymentStatusDefSaga